import axios from "axios";
import { SEARCH_PAGE_RESULT_COUNT } from "../../../config";
export function fetchAutoComplete(
  searchValue,
  country,
  institute,
  orgClassification,
  token,
  platform
) {
  let queryString = `q=${searchValue}&cat=&country=${country}&disc=&institution=${institute}&limit=${SEARCH_PAGE_RESULT_COUNT}&offset=0&token=${token}&type=all&orgClassification=${orgClassification}`;
  
  // Add platform parameter if provided (for LMS flow with etext)
  if (platform) {
    queryString += `&platform=${platform}`;
  }
  
  // Add source parameter (indicates coming from Exchange UI, not Exchange UI Component)
  queryString += `&source=exchange-ui`;
  
  return axios.get(
    `${window.location.protocol}//${
      process.env.REACT_APP_EXCHANGE_URL
        ? process.env.REACT_APP_EXCHANGE_URL
        : window.location.host
    }/api/autoComplete?${queryString}`
  );
}
